import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CreateBoxCodeData, CreatePartDetailData, GetBoxCodeDetailList as _GetBoxCodeDetailList, GetBoxCodeDetailPrintData as _GetBoxCodeDetailPrintData } from '@/api/DeliveryCode';
import { GetDetailList } from '@/api/MaintainDeliveryNote2';
import { mapActions, mapGetters } from 'vuex';
import util from '@/libs/util';
import changeOrderDialog from './changeOrderDialog';
export default {
  components: {
    changeOrderDialog: changeOrderDialog
  },
  mounted: function mounted() {},
  data: function data() {
    var DELIVERY_QTYValid = function DELIVERY_QTYValid(cellValue) {
      var DELIVERY_QTY = Number(cellValue.DELIVERY_QTY);

      if (DELIVERY_QTY === 0) {
        return new Error('货数量数量不能为0');
      }
    };

    var SPQValid = function SPQValid(cellValue) {
      // console.log('cellValue',cellValue);
      // console.log(cellValue.row.DELIVERY_QTY);
      var SPQ = Number(cellValue.cellValue);
      var QTY = cellValue.row.DELIVERY_QTY; // console.log('SPQ',SPQ);
      // console.log('QTY',QTY);

      if (SPQ === 0) {
        return new Error('内包装数量不能为0');
      } else if (SPQ > QTY) {
        return new Error('内包装数量不能大于送货数量');
      }
    };

    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      pageInfo: {
        TotalCount: null,
        size: null,
        current: null
      },
      loading: false,
      editConfig: {
        trigger: null,
        mode: null,
        showStatus: true
      },
      tableHeaderInfo: {},
      canEdit: false,
      vxeRules: {
        DELIVERY_QTY: [{
          required: true,
          message: '送货数量必须填写'
        }, {
          validator: DELIVERY_QTYValid
        }],
        SPQ: [{
          required: true,
          message: '内箱包装数量必须填写'
        }, {
          validator: SPQValid
        }]
      },
      isShowChangeOrderDialog: false,
      isShowPageBar: true,
      isShowOptionColumn: false,
      formData: {
        ID: null,
        DELIVERY_NO: null,
        // 送货单号
        DESCRIPTION: null,
        // 备注
        CREATETIME: null,
        // 创建日期
        VENDOR_CODE: null,
        // 供应商代码
        VENDOR_NAME: null // 供应商名称

      },
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      orderInfo: null,
      submitID: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/OuterBoxLabelManagement', ['setOrderStatu'])), {}, {
    // 设置ID
    setID: function setID(id) {
      this.submitID = id;
    },
    // 打开选择送货单dialog
    ShowChangeOrderDialog: function ShowChangeOrderDialog() {
      var _this = this;

      this.isShowChangeOrderDialog = true;
      this.$nextTick(function () {
        _this.$refs.changeOrderDialog.getOrderlist();
      });
    },
    // 组合打印前校验
    valiPrintParBarcodeGroup: function valiPrintParBarcodeGroup(ID) {
      var _this2 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          var params, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  params = {
                    // Page:1,
                    // Limit:10,
                    MST_ID: ID,
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  };
                  _this2.loading = true;
                  _context.next = 4;
                  return _GetBoxCodeDetailList(params);

                case 4:
                  res = _context.sent;
                  _this2.loading = false;
                  console.log('组合打印前校验', res);

                  if (res.code === 0) {
                    if (res.data.length === 0) {
                      resolve(false);
                    } else {
                      resolve(true);
                    }
                  }

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 获取外箱标签List
    GetBoxCodeDetailList: function GetBoxCodeDetailList(orderInfo) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.orderInfo = orderInfo;
                params = {
                  // Page:1,
                  // Limit:10,
                  MST_ID: _this3.submitID ? _this3.submitID : _this3.orderInfo.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                }; // this.$openLoading('数据获取中...')

                _this3.loading = true;
                _context2.next = 5;
                return _GetBoxCodeDetailList(params);

              case 5:
                res = _context2.sent;
                _this3.loading = false; // this.$closeLoading()

                console.log('外箱标签list res', res);

                if (res.code === 0) {
                  _this3.tabelData = res.data;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 获取外箱标签明细List
    GetBoxCodeDetailPrintData: function GetBoxCodeDetailPrintData(orderInfo) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.orderInfo = orderInfo;
                params = {
                  // Page:1,
                  // Limit:10,
                  MST_ID: _this4.submitID ? _this4.submitID : _this4.orderInfo.ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context3.next = 4;
                return _GetBoxCodeDetailPrintData(params);

              case 4:
                res = _context3.sent;
                console.log('外箱标签明细list res', res);

                if (res.code === 0) {
                  _this4.tabelData = res.data;
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 生成标签
    handleCreateOutBoxBarcode: function handleCreateOutBoxBarcode(TabelHeaderData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res, res2;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // console.log(this.formData);
                // console.log('this.submitID',this.submitID);
                params = {
                  ID: _this5.submitID ? _this5.submitID : _this5.orderInfo.ID,
                  CREATORID: _this5.userInfo.USER_NAME,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                console.log('params', params);
                _context4.next = 4;
                return CreatePartDetailData(params);

              case 4:
                res = _context4.sent;
                console.log('res', res);

                if (!(res.code === 0)) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 9;
                return CreateBoxCodeData(params);

              case 9:
                res2 = _context4.sent;
                console.log('res2', res2);

                _this5.GetBoxCodeDetailList(TabelHeaderData);

                _context4.next = 15;
                break;

              case 14:
                _this5.$message.warning(res.message);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 明细dialog确定按钮回调
    cbDialogSubmit: function cbDialogSubmit(selectRecords) {
      // console.log(selectRecords);
      this.formData.ID = selectRecords.ID;
      this.formData.DELIVERY_NO = selectRecords.DELIVERY_NO;
      this.formData.DESCRIPTION = selectRecords.DESCRIPTION;
      this.formData.CREATETIME = selectRecords.CREATETIME;
      this.formData.VENDOR_CODE = selectRecords.VENDOR_CODE;
      this.formData.VENDOR_NAME = selectRecords.VENDOR_NAME; // this.Bus.emit('onSelectOrderForOuterBox',selectRecords)

      this.$emit('onDialogSubmit_OuterBoxLabelManagement', selectRecords);
    },
    // 明细dialog关闭
    closeChangeOrderDialog: function closeChangeOrderDialog() {
      this.isShowChangeOrderDialog = false;
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.current = index;
      this.getOrderInfo();
    },
    // 切换页码
    handleSizeChange: function handleSizeChange(value) {
      // console.log(value);
      this.pageInfo.size = value;
      this.getOrderInfo();
    }
  }),
  watch: {
    $OuterBoxLabelManagementOrderState: {
      handler: function handler(nawValue) {
        if (nawValue === 'listShow') {
          this.tabelData = [];
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$OuterBoxLabelManagementOrderState', 'userinfo'])),
  beforeDestroy: function beforeDestroy() {
    console.log('销毁');
    this.setOrderStatu('listShow');
    this.Bus.off('onBeforeSaveEditOrder');
    this.Bus.off('onShowAddRowDialog');
    this.Bus.off('onClickaddOrder');
  }
};